import styled from 'styled-components'
import { colors } from '../../../styles/colors'

export const StyledCollapseTrigger = styled.div`
  cursor: pointer;

  
  h1 {
    display: flex;
    align-items: flex-start;
  }
  @media screen and (max-width: 1080px) {
    margin-left: 0px;

  }

`
export const StyledValidationMessage = styled.div`
  margin-top: 4px;
  font-size: 80%;
  color: ${colors.red};
`
